import { Inject, Injectable } from '@angular/core';
import { API_URL } from '../../app-store-providers';
import { HttpClient } from '@angular/common/http';
import { EntityTypes } from '../../entity/entity-types';
import { StoreBaseService } from '../../common/base.service';
import { ArticleTextContentPayload } from './models/text-content-payload';
import { ArticleTextContent } from './models/text-content';

@Injectable({
  providedIn: 'root'
})
export class ArticleTextContentService
  extends StoreBaseService<ArticleTextContent, ArticleTextContentPayload> {

  get entityType(): string {
    return EntityTypes.articleTextContent;
  }

  get resourceName(): string {
    return 'text-content';
  }

  constructor(
    @Inject(API_URL) apiUrl: string,
    http: HttpClient
  ) {
    super(apiUrl, http);
  }
}
